<div class="dock-content">
  <!-- <svg-icon
    (click)="close()"
    class="close x-container"
    svgClass="fill-white w-4 h-4"
    src="assets/svg/x.svg"
  ></svg-icon> -->
  <button class="btn-primary-v3 close x-container" (click)="close()">x</button>
  <div class="title">
    {{ title }}
  </div>

  <div class="body">
    @switch (activeTab.name) {
      @case (tabNamesEnums.MECHANICS) {
        <app-mechanics></app-mechanics>
      }
      @case (tabNamesEnums.COIN) {
        <app-coin></app-coin>
      }
      @case (tabNamesEnums.ABS_SETTINGS) {
        <app-auto-bet-settings></app-auto-bet-settings>
      }
      @case (tabNamesEnums.PROFILE) {
        <app-profile></app-profile>
      }
    }
  </div>
</div>
